export const REACT_APP_API_MEDIA_URL =
  'https://dwlelearningstorage.blob.core.windows.net'
